/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Task_DeletedInputs */

const cs_enum_task_deleted = /** @type {(inputs: Enum_Task_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol smazán`)
};

const en_enum_task_deleted = /** @type {(inputs: Enum_Task_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task deleted`)
};

/**
* | output |
* | --- |
* | "Task deleted" |
*
* @param {Enum_Task_DeletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_task_deleted = /** @type {((inputs?: Enum_Task_DeletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Task_DeletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_task_deleted(inputs)
	return cs_enum_task_deleted(inputs)
});